module.exports = __webpack_public_path__ + "img/stu_rings2.539cd638.png";